import { Box, Checkbox, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { QuotationFormValues } from "../../../types";
import {
  QUOTATION_FLOOR_FIELDS,
  QUOTATION_FORM_I18N_PREFIX,
  QUOTATION_SECTION_KEYS,
} from "../data";
import { renderFieldControls } from "../VehicleDetails/FormControls";
import QuotationInputCard from "./QuotationInputCard";
import { useStyles } from "./styles";

type Props = {
  formValues: QuotationFormValues;
  updateField: (field: keyof QuotationFormValues, value: string | boolean) => void;
};

const FloorPanel = ({ formValues, updateField }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <QuotationInputCard titleKey={QUOTATION_SECTION_KEYS.FLOOR}>
      <Box className={styles.floorGrid}>
        {renderFieldControls(QUOTATION_FLOOR_FIELDS, formValues, updateField)}

        <Box className={styles.checkboxField}>
          <Typography className={styles.checkboxLabelSpacer}>&nbsp;</Typography>
          <Box className={styles.checkboxBox}>
            <Checkbox
              size="small"
              checked={formValues.reinforcedModel}
              onChange={(event) =>
                updateField("reinforcedModel", event.target.checked)
              }
              sx={{ p: 0 }}
            />
            <Typography className={styles.checkboxLabel}>
              {t(`${QUOTATION_FORM_I18N_PREFIX}.FIELDS.REINFORCED_MODEL`)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </QuotationInputCard>
  );
};

export default FloorPanel;
